import { Link } from "react-router-dom";
import { useSessione } from "../sessione";

/** Appare solo quando manca un prerequisito, senza interrompere il lavoro. */
export function PrimiPassi({ clientiMancanti, catalogoMancante }: {
  clientiMancanti: boolean;
  catalogoMancante: boolean;
}) {
  const { utente } = useSessione();
  if (!clientiMancanti && !catalogoMancante) return null;
  const gestisceClienti = utente?.ruolo !== "OPERATORE";
  const gestisceCatalogo = utente?.ruolo === "AMMINISTRATORE";
  return (
    <section className="primi-passi" aria-label="Per iniziare">
      <h2>Prima di segnare le ore</h2>
      <p>Sceglierai il cliente e la prestazione svolta. Manca ancora:</p>
      <ul>
        {clientiMancanti && <li>
          {gestisceClienti ? <Link to="/clienti?nuovo=1">Aggiungi il primo cliente</Link>
            : "Chiedi a chi fattura di aggiungere i clienti dello studio."}
        </li>}
        {catalogoMancante && <li>
          {gestisceCatalogo ? <Link to="/impostazioni/catalogo">Prepara il catalogo delle prestazioni</Link>
            : "Chiedi all'amministratore di preparare il catalogo delle prestazioni."}
        </li>}
      </ul>
    </section>
  );
}
